import "./App.css";
import Sidebar from "./components/Sidebar";
import Dashboard from "./pages/Dashboard";
import About from "./pages/About";
import { Router, Route, Routes, useNavigate } from "react-router-dom";
import ContactUs from "./pages/ContactUs";
import WebDesign from "./pages/WebDesign";
import MobileApp from "./pages/MobileApp";
import AIandML from "./pages/AIandML";
import Software from "./pages/Software";
import UIUX from "./pages/UIUX";
import DigitalMarketing from "./pages/DigitalMarketing";
import Careers from "./pages/Careers";
import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import WhatWeDo from "./pages/WhatWeDo";
import WhyUs from "./pages/WhyUs";
import WhoWeServe from "./pages/WhoWeServe";
import Services from "./pages/Services";
import Cloud from "./pages/Cloud";
import Kubernetes from "./pages/Kubernetes";
import Leaders from "./pages/Leaders";
import Devops from "./pages/Devops";
import Staff from "./pages/Staff";
import Contract from "./pages/contract";
import Permanent from "./pages/Permanent";

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  function handleWindowSizeChange() {
    if (window.innerWidth <= 1300) {
      dispatch({ type: "MOBILE_VIEW", payload: true });
    } else {
      dispatch({ type: "MOBILE_VIEW", payload: false });
    }
  }

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/staff_augmentation" element={<Staff />} />
        <Route path="/about" element={<About />} />
        <Route path="/leaders" element={<Leaders />} />
        <Route path="/uiux" element={<UIUX />} />
        <Route path="/services" element={<Services />} />
        <Route path="/data_analytics" element={<WebDesign />} />
        <Route path="/mobile" element={<MobileApp />} />
        <Route path="/ai_ml" element={<AIandML />} />
        <Route path="/webdesign" element={<WebDesign />} />
        <Route path="/managed_it" element={<DigitalMarketing />} />
        <Route path="/software" element={<Software />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/services" element={<WhatWeDo />} />
        <Route path="/cloud" element={<Cloud />} />
        <Route path="/kubernetes" element={<Kubernetes />} />
        <Route path="/why_us" element={<WhyUs />} />
        <Route path="/devops" element={<Devops />} />
        <Route path="/industries" element={<WhoWeServe />} />
        <Route path="/permanent_hiring" element={<Permanent />} />
        <Route path="/contract_hiring" element={<Contract />} />
      </Routes>
    </div>
  );
}

export default App;
